var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x90\x8D\xE7\xA7\xB0=\xE6\x94\xB6\xE8\xB5\xB7, \xE5\xAF\xBC\xE8\x88\xAA=\xE4\xBE\xA7\xE8\xBE\xB9\xE6\xA0\x8F, \xE8\x8B\xB1\xE6\x96\x87\xE5\x90\x8D=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4",
    d: "M11.1225 8.4532C11.3729 8.65337 11.3729 9.03413 11.1225 9.2343L7.00663 12.5246C6.67922 12.7863 6.19443 12.5532 6.19443 12.134L6.19443 5.55346C6.19443 5.13429 6.67922 4.90117 7.00663 5.16291L11.1225 8.4532Z",
    fill: "#222627"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.c0310a93198f57965500890efc70897a.svg";
export { ForwardRef as ReactComponent };